// @ts-check
// Chamadas da importação de planilhas (docs/arquitetura-appcrm/08-contrato-importacao.md, seção 4).
import { api } from './api-client.js';

/**
 * @typedef {{ rowNumber: number, status: 'CREATED' | 'UPDATED' | 'SKIPPED' | 'FAILED', recordId: string | null, matchedBy?: string | null,
 *   errorCode?: string, message?: string, fieldName?: string | null }} ImportRowResult
 * @typedef {{ results: ImportRowResult[], createdRelations: Array<{ fieldName: string, objectNameSingular: string, recordId: string, label: string }>,
 *   summary: { created: number, updated: number, skipped: number, failed: number }, counters?: Record<string, number> }} ImportBatchResult
 */

/**
 * @param {string} objectNamePlural
 * @param {{ records: any[], duplicateStrategy: string, duplicateCriteria?: string[] | null, createMissingRelations?: string[] }} payload
 * @returns {Promise<ImportBatchResult>}
 */
export async function importRecordsBatch(objectNamePlural, payload) {
  const response = await api.post(`/rest/${objectNamePlural}/import`, payload);
  return response.data.importRecords;
}

/**
 * @param {{ records: any[], duplicateStrategy: string, createMissingRelations?: string[] }} payload
 * @returns {Promise<ImportBatchResult>}
 */
export async function importFamiliesBatch(payload) {
  const response = await api.post('/rest/imports/family-enrollment', payload);
  return response.data.importFamilies;
}
